import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import dimensions from '../../common/theme/dimensions';
import { map } from '../core/MapView';
import { usePrevious } from '../../reactHelper';
import { useAttributePreference } from '../../common/util/preferences';

const MapSelectedDevice = ({ mapReady }) => {
  const currentTime = useSelector((state) => state.devices.selectTime);
  const currentId = useSelector((state) => state.devices.selectedId);
  const previousTime = usePrevious(currentTime);
  const previousId = usePrevious(currentId);

  const selectZoom = useAttributePreference('web.selectZoom', 10);
  const mapFollow = useAttributePreference('mapFollow', false);

  // 2ECOMP: PremiumUI Refresh — não voar até device oculto no mapa
  const hiddenDeviceIds = useSelector((state) => state.devices.hiddenDeviceIds);
  const hiddenSet = useMemo(() => new Set(hiddenDeviceIds), [hiddenDeviceIds]);

  const position = useSelector((state) => state.session.positions[currentId]);

  const previousPosition = usePrevious(position);

  useEffect(() => {
    if (!mapReady) return;

    // 2ECOMP: PremiumUI Refresh — ignorar device oculto
    if (currentId && hiddenSet.has(currentId)) return;

    const positionChanged = position && (!previousPosition || position.latitude !== previousPosition.latitude || position.longitude !== previousPosition.longitude);

    if ((currentId !== previousId || currentTime !== previousTime || (mapFollow && positionChanged)) && position) {
      const currentZoom = map.getZoom();
      const targetZoom = Math.max(currentZoom, selectZoom);

      // Se é uma nova seleção (device diferente), usar flyTo com animação rápida
      // Se é apenas follow de movimento, usar easeTo suave
      if (currentId !== previousId) {
        // Nova seleção: animação rápida para evitar "piscar"
        map.flyTo({
          center: [position.longitude, position.latitude],
          zoom: targetZoom,
          offset: [0, -dimensions.popupMapOffset / 2],
          duration: 500, // 500ms - rápido mas suave
          essential: true,
        });
      } else {
        // Follow de movimento: animação suave
        map.easeTo({
          center: [position.longitude, position.latitude],
          zoom: targetZoom,
          offset: [0, -dimensions.popupMapOffset / 2],
          duration: 300,
        });
      }
    }
  }, [currentId, previousId, currentTime, previousTime, mapFollow, position, selectZoom, hiddenSet, mapReady]);

  return null;
};

MapSelectedDevice.handlesMapReady = true;

export default MapSelectedDevice;
